import type { WebPresets } from '@studio/types';

const getWebPresetName = (webPresets: Readonly<WebPresets.Get.WebPreset[]>, webEncoderProfileId?: string) =>
  webEncoderProfileId && webPresets.find((wp) => wp.uuid === webEncoderProfileId)?.name;

export default getWebPresetName;
